import classNames from 'classnames';
import React from 'react';
import * as Render from '../Base/Render';
import withSrcSets from '../Containers/withSrcSets';
import ImageBlock from '../ImageBlock';
import Icons from './icons';
import Option from './option';
const ImageBlockWithSrcSets = withSrcSets(ImageBlock);

class SelfTestQuestion extends React.Component {
  options = [];

  state = {
    isValid: null,
    isValidated: false,
  };

  addOptionToValidation(option) {
    this.options.push(option);
  }

  validateQuestion() {
    let isValid = true;
    this.options.forEach((option) => {
      if (option.state.isValid !== true) {
        isValid = false;
      }
    });

    this.setState({
      isValid: isValid,
    });

    return isValid;
  }

  resetQuestion() {
    this.options.forEach((option) => option.resetOption());

    this.setState({
      isValid: null,
      isValidated: false,
    });
  }

  componentDidMount() {
    this.props.addCtrlToValidation(this);
  }

  render() {
    if (!this.props.AnswerAlternatives) return null;

    const classes = classNames({
      'c-self-test__question': true,
      'c-self-test__question--is-valid': this.state.isValid,
      'c-self-test__question--is-error': this.state.isValid === false,
    });

    return (
      <div className={classes}>
        <fieldset>
          <legend className="c-self-test__optionheading">
            <div className="c-self-test__optionheading__text">
              {this.props.QuestionText}
            </div>
            {this.state.isValid !== null && (
              <Icons iconType={this.state.isValid} />
            )}
          </legend>
          <Render.Block
            blocks={this.props.Image}
            propertyName="Image"
            Modifiers={{ 'c-self-test__imageblock': true }}
          >
            <ImageBlockWithSrcSets
              UseZoom={false}
              Sizes={{
                sizes: '(min-width: 1024px) 833px, 100vw',
              }}
            />
          </Render.Block>

          <div className="c-self-test__optiongroup">
            {this.props.AnswerAlternatives.map((qAlternative, key) => (
              <Option
                key={key}
                {...qAlternative}
                addOptionToValidation={(option) =>
                  this.addOptionToValidation(option)
                }
              />
            ))}
          </div>
        </fieldset>
      </div>
    );
  }
}

export default SelfTestQuestion;
